// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2366":"f59049241efffb93","9556":"5491f6662a430b76","9659":"51adb74b159c2609"}[chunkId] + ".css";
};